export default "__VITE_ASSET__C$_qSbmX__"